/**
 * Mirrors packages/amgsicbo_v2/lib/core/constants/api_constants.dart
 * + game_constants.dart for endpoints, game keys, and the reference resolution.
 */
export const API_BASE = 'https://staginggameapi.tbgcablecar.xyz/api';

export const Endpoints = {
  login: `${API_BASE}/action/login`,
  openGame: `${API_BASE}/action/opengame`,
  checkBalance: `${API_BASE}/action/balance`,
  getInfo: `${API_BASE}/action/getinfo`,
  placeBet: `${API_BASE}/action/bet`,
  getHistory: `${API_BASE}/action/bethistory`,
} as const;

export const GAME_KEY_SINGLE = 'SBA1';
export const GAME_KEY_MULTI = 'SBAM';
export const MULTIPLAYER_HUB_URL =
  'https://staginggameapi.tbgcablecar.xyz/sekbaohub';
export const DEFAULT_AGENT_ID = 'Agent1';

/** Reference stage size — mirrors apps/amg_sicbo_v2/web/index.html */
export const REF_WIDTH = 1792;
export const REF_HEIGHT = 828;

/** Hardcoded test creds (LobbyScreen defaults in amgsicbo_v2). */
export const DEFAULT_USER_NAME = 'user5';
export const DEFAULT_PASSWORD = '123456';

/** Default game config — used until /action/getinfo overrides. */
export const DEFAULT_GAME_CONFIG = {
  minBet: 1000,
  maxBet: 100000,
  chipValues: [1000, 5000, 10000, 50000, 100000, 500000] as const,
};

/** ms — full dice-bowl reveal duration (start spin + open) */
export const DICE_REVEAL_DURATION_MS = 1800;
